import { render, staticRenderFns } from "./statisticsData.vue?vue&type=template&id=cb34cafa&scoped=true"
import script from "./statisticsData.vue?vue&type=script&lang=js"
export * from "./statisticsData.vue?vue&type=script&lang=js"
import style0 from "./statisticsData.vue?vue&type=style&index=0&id=cb34cafa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb34cafa",
  null
  
)

export default component.exports